const initialState = {
  dismissedShopifyAlert: false,
};

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case 'UI_DISMISS_SHOPIFY_ALERT':
      return { ...state, dismissedShopifyAlert: true };
    case 'AUTH_LOGOUT':
      return initialState;
    default:
      return state;
  }
}


